import { Box, Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Autosizer, Scrollbar } from 'app/components';
import React from 'react';
import { FixedSizeList } from 'react-window';
const ChecklistInspectionFilterTransportList = (props) => {
    const { items, checkedId, onClick } = props;
    return (React.createElement(Box, { sx: {
            width: '100%',
            height: '100%',
            '.simplebar-offset > div': {
                '&::-webkit-scrollbar': {
                    width: 0,
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent',
                    boxShadow: 'none',
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                },
            },
        } },
        React.createElement(Autosizer, null, ({ height, width }) => (React.createElement(Box, { sx: { height, width } },
            React.createElement(Scrollbar, null, ({ scrollableNodeRef, contentNodeRef }) => (React.createElement(FixedSizeList, { itemSize: 24, height: height, itemCount: items.length, innerRef: contentNodeRef, outerRef: scrollableNodeRef, itemData: {
                    items,
                    checkedId,
                    onClick,
                } }, ChecklistInspectionFilterTransportListItemRender))))))));
};
const ChecklistInspectionFilterTransportListItemRender = ({ data, index, style }) => {
    const { items, checkedId, onClick } = data;
    return (React.createElement(ListItem, { key: index, style: style, onClick: () => onClick(items[index].id), sx: (theme) => ({
            width: '100%',
            userSelect: 'none',
            padding: theme.spacing(0),
            borderRadius: '0',
            '.MuiAvatar-circular': {
                width: '24px',
                height: '24px',
            },
            '.MuiListItemButton-root': {
                height: '100%',
                padding: theme.spacing(0, 2),
                borderRadius: '0',
            },
            '.MuiListItemText-root': {
                margin: theme.spacing(0),
            },
            '.MuiListItemIcon-root': {
                minWidth: '24px',
            },
            '.MuiCheckbox-root': {
                padding: theme.spacing(0),
                marginLeft: '-3px',
                svg: {
                    fontSize: '18px',
                },
            },
        }) },
        React.createElement(ListItemButton, null,
            React.createElement(ListItemIcon, null,
                React.createElement(Checkbox, { size: 'small', edge: 'end', disableRipple: true, checked: checkedId.includes(items[index].id) })),
            React.createElement(ListItemText, { primary: items[index].number }))));
};
export default ChecklistInspectionFilterTransportList;
